import { SweetAlert2Wrapper } from '@common/sweet-alert-wrapper';

const defaults = {
};

class Alert extends SweetAlert2Wrapper {
    constructor(params) {
        super();
        this.required = ['title', 'text'];
        this.optional = ['icon', 'showConfirmButton', 'confirmButtonText', 'cancelButtonText', 'showDenyButton', 'showCancelButton', 'allowOutsideClick', 'allowEscapeKey', 'focusConfirm', 'reverseButtons', 'padding', 'buttonsStyling', 'customClass'];
        this.allowed = [...this.required, ...this.optional];
        this.config = Object.assign(defaults, this.validate(params));
        this.setTextAsHTML();
    }
}

class Success extends Alert {
    constructor(message, title = 'Success', params = {}) {
        super({title: title, text: message, icon: 'success', ...params});
    }
}

class Failure extends Alert {
    constructor(message, title = 'Error', params = {}) {
        super({title: title, text: message, icon: 'error', ...params});
    }
}

class Warning extends Alert {
    constructor(message, title = 'Attention!', params = {}) {
        super({title: title, text: message, icon: 'warning', ...params});
    }
}

/**
 * @function alert
 * @param {string} title Title of alert
 * @param {string} text Text for alert (can be HTML or plain text)
 * @param {string} icon Type of alert (defaults to none, accepted values 'success', 'error', 'warning', 'info' or 'question')
 * @param {object} params Additional parameters to customize the alert.
 * @returns Promise
 */
export function alert(title, text, icon, params = {}) {
    const c = new Alert({title, text, icon, ...params});
    return c.show();
}

/**
 * @function success
 * @param {string} message Text for alert (can be HTML or plain text)
 * @returns Promise
 */
export function success(message, title, params) {
    const s = new Success(message, title, params);
    return s.show();
}

/**
 * @function failure
 * @param {string} message Text for alert (can be HTML or plain text)
 * @returns Promise
 */
export function failure(message, title, params) {
    const f = new Failure(message, title, params);
    return f.show();
}

/**
 * @function warning
 * @param {string} message Text for alert (can be HTML or plain text)
 * @returns Promise
 */
export function warning(message, title, params) {
    const w = new Warning(message, title, params);
    return w.show();
}
